<template>
  <div class="container">
    <p class="buttons is-pulled-right">
      <div class="button is-secondary is-rounded" @click="add">
        <span class="icon">
          <i class="fa fa-plus"></i>
        </span>
        <span>{{ $t("add") }}</span>
      </div>
    </p>
    <h5 class="title is-5 pt-3">{{ $t("items") }}</h5>
    <table class="table is-bordered is-fullwidth" v-if="meta.items">
      <thead>
        <tr>
          <th>{{ $t("quantity") }}</th>
          <th>{{ $t("name") }}</th>
          <th>{{ $t("price") }}</th>
          <th>{{ $t("discount") }}</th>
          <th>{{ $t("type") }}</th>
          <th>{{ $t("meassurement unit") }}</th>
          <th>{{ $t("taxable unit") }}</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(rsrc, ridx) in meta.items" :key="ridx">
          <td>
            <input
              type="text"
              class="input"
              v-model="meta.items[ridx].quantity"
            />
          </td>
          <td>
            <input type="text" class="input" v-model="meta.items[ridx].name" />
          </td>
          <td>
            <input type="text" class="input" v-model="meta.items[ridx].price" />
          </td>
          <td>
            <input
              type="text"
              class="input"
              v-model="meta.items[ridx].discount"
            />
          </td>
          <td>
            <input type="text" class="input" v-model="meta.items[ridx].type" />
          </td>
          <td>
            <input
              type="text"
              class="input"
              v-model="meta.items[ridx].meassurement_unit"
            />
          </td>
          <td>
            <input
              type="text"
              class="input"
              v-model="meta.items[ridx].taxable_unit"
            />
          </td>
          <td>
            <div
              class="button is-secondary has-text-danger is-rounded"
              @click="meta.items.splice(ridx, 1)"
              :data-tooltip="$t('delete')"
            >
              <span class="icon">
                <i class="fa fa-trash"></i>
              </span>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  data() {
    return {
      meta: { items: [] },
    };
  },
  methods: {
    get_data() {
      return this.meta.items;
    },
    set_data(data) {
      this.meta.items = data;
    },
    clear() {
      this.meta = {
        items: [],
      };
    },
    add() {
      let idx = this.meta.items.length + 1;
      this.meta.items.push({
        quantity: idx,
        name: `Producto ${idx}`,
        price: (Number(idx)*10*Math.random()).toFixed(2),
        discount: "0",
        type: "S",
        meassurement_unit: "UNI",
        taxable_unit: "1",
      });
    },
  },
};
</script>
